import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CategoriesService } from 'src/app/shared/services/wordpress-api/categories.service';
import { MediaService } from 'src/app/shared/services/wordpress-api/media.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-blog-img-card',
  templateUrl: './blog-img-card.component.html',
  styleUrls: ['./blog-img-card.component.scss'],
})
export class BlogImgCardComponent implements OnInit {
  @Input() category: any;
  domain = environment.wordPressApiUrl;
  categoryName: any;
  categoryData: any;
  constructor(
    private mediaService: MediaService,
    private categoriesService: CategoriesService
  ) {}

  ngOnInit(): void {
    this.getCategory(this.category.categories[0]);
  }

  getCategory(id) {
    this.categoryData = this.categoriesService.getCatByIdLocalStorage(id);
    this.categoryName = this.categoryData?.name;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.getMedia();
  }

  getMedia() {
    if (!this.category?.featured_media.id) {
      this.mediaService.getMedia(this.category?.featured_media).then(
        (data: any) => {
          this.category.featured_media = data;
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
  }
}
